import { createIcon } from '../shared'

const ShareIcon = createIcon(
  ({ color }) => (
    <path
      d="M16.4968 1.67407C18.694 1.82435 20.012 4.26134 18.8609 6.19882L12.3627 17.1306C10.9885 19.4427 7.50127 18.9182 6.86868 16.3038L5.48765 10.6007L1.62372 6.80835C-0.293384 4.92698 1.03735 1.66679 3.72414 1.66675H16.2819L16.4968 1.67407ZM3.61428 3.33748C2.49546 3.4231 1.96531 4.80774 2.79152 5.61857L6.37714 9.13746L12.5181 5.6438C12.9181 5.41621 13.4274 5.55628 13.655 5.9563C13.8821 6.35623 13.7423 6.8649 13.3425 7.09237L7.1999 10.5868L8.48815 15.9116C8.76914 17.0735 10.3195 17.3072 10.9304 16.2794L17.4278 5.34758C17.9393 4.48692 17.3538 3.4034 16.3772 3.33667L16.2819 3.33342H3.72414L3.61428 3.33748Z"
      fill={color}
    />
  ),
  '0 0 20 20',
  'ShareIcon',
)

export { ShareIcon }
